import { useEffect, useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { FormSchema, FormValues, initialFormValues } from '../../schema';
import { ConfirmDialog } from '../../components';
import { BasicInfoTab } from './BasicInfoTab';
import { Group } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  open: boolean;
  formMode: FormMode;
  initialData?: Group;
  onSubmit: (data: FormValues) => void;
  onClose: () => void;
  onAdd?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  onCopy?: () => void;
}

const FormDialog = ({
  open,
  initialData,
  onClose,
  onSubmit,
  onAdd,
  onEdit,
  onDelete,
  onCopy,
  formMode
}: FormDialogProps) => {
  const [isFormDirty, setIsFormDirty] = useState<boolean>(false);

  useEffect(() => {
    if (!open) {
      setIsFormDirty(false);
    }
  }, [open]);

  const handleSubmit = (data: FormValues) => {
    onSubmit(data);
    setIsFormDirty(false);
    onClose();
  };

  const getDialogTitle = () => {
    switch (formMode) {
      case 'add':
        return 'Mới';
      case 'edit':
        return 'Sửa';
      case 'view':
        return 'Xem';
      default:
        return 'Nhóm yếu tố';
    }
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={getDialogTitle()}
        maxWidth='xl'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={formMode}
          hasAritoActionBar={false}
          schema={FormSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialFormValues) as FormValues}
          className='w-[900px]'
          headerFields={
            <div onChange={() => setIsFormDirty(true)}>
              <BasicInfoTab formMode={formMode} />
            </div>
          }
          bottomBar={
            <BottomActionBarV2
              mode={formMode}
              onClose={onClose}
              onAdd={onAdd}
              onEdit={onEdit}
              onDelete={onDelete}
              onCopy={onCopy}
            />
          }
        />
      </DialogV2>
    </>
  );
};

export default FormDialog;
